import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';

export function usePermissions(type?: number) {
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    setLoading(false);
  }, [user]);

  const {
    isAdmin,
    isAuditor,
    isSpecificationsApprover,
    isCompanyAgreementApprover,
    isImplementationApprover,
    isAllowed,
    canCreate,
    isRegularUser,
  } = useMemo(() => {
    const isAdmin = !!user?.roles.find((role: { id: number; type: number }) => role.type === 4);
    const isAuditor = !!user?.roles.find((role: { id: number; type: number }) => role.type === 5);
    const isRegularUser = true;
    const isSpecificationsApprover = !!user?.roles.find(
      (role: { id: number; type: number }) => role.type === 1,
    );
    const isCompanyAgreementApprover = !!user?.roles.find(
      (role: { id: number; type: number }) => role.type === 2,
    );
    const isImplementationApprover = !!user?.roles.find(
      (role: { id: number; type: number }) => role.type === 3,
    );
    const isAllowed =
      (isSpecificationsApprover && type === 1) ||
      (isCompanyAgreementApprover && type === 2) ||
      (isImplementationApprover && type === 3);
    const canCreate = true;
    return {
      isAdmin,
      isAuditor,
      isSpecificationsApprover,
      isCompanyAgreementApprover,
      isImplementationApprover,
      isAllowed,
      canCreate,
      isRegularUser,
    };
  }, [user?.roles, type]);

  return {
    isAdmin,
    isAuditor,
    isSpecificationsApprover,
    isCompanyAgreementApprover,
    isImplementationApprover,
    isAllowed,
    canCreate,
    loading,
    isRegularUser,
  };
}
